import { GoogleMap } from "@react-google-maps/api";
import { useEffect, useRef } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import {  getRegionsBoundaries, setIsListView, topSelectBoundaryDepth } from "../../features/boundaries/boundariesSlice";
import CitiesBoundaries from "../../components/boundaries/CitiesBoundaries";
import RegionsBoundaries from "../../components/boundaries/RegionsBoundaries";
import TownsBoundaries from "../../components/boundaries/TownsBoundaries";
import AbsoluteSpinner from "../../components/shared/spinners/AbsoluteSpinner";
import { getAllUsersLocation, setFilteredUsersLocations } from "../../features/locs/locsSlice";
import UserLocations from "../../components/boundaries/UserLocations";
import UserOverlay from "../../components/boundaries/UserOverlay";
import { BiSolidRightArrow, BiSolidLeftArrow } from "react-icons/bi";
import UserList from "../../components/boundaries/UserList";
import Btn from "../../components/shared/button/Btn"
import InputPlacesForBoundaries from "../../components/shared/customInput/InputPlacesForBoundaries";

const Container = styled.div`
  width: calc(100vw - 80px);
  height: calc(100vh - 60px);
  position: relative;

  .controller{
    height: 60px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    background-color: ${({theme}) => theme.secondaryBgColor};
    border-bottom: 1px solid ${({theme}) => theme.mainTextColor};

    .part-list{
      display: flex;
      align-items: center;
      gap: 30px;

      .part-item{
        font-size: 13px;
        display: flex;
        gap: 5px;
        align-items: center;
        font-weight: var(--font-weight-lg);
        color: ${({theme}) => theme.mainTexColor};
        text-decoration: none;
        cursor: initial;


        .arr-icon{
          font-size: .6rem;
        }

      }

      .clickable{
        cursor: pointer;

        &:hover{
          text-decoration: underline;
        }
      }

    }
  }

  .input-wrapper{
    position: absolute;
    top: 10px;
    left: 10px;
  }

  .btn-wrapper{
      position: absolute;
      top: 10px;
      right: 60px;

      .filter-btn{
        background-color: ${({theme}) => theme.mainBgColor};
        padding: 0 20px;
        display: flex;
        align-items: center;
        gap: 5px;
        border-radius: 10px;
        height: 40px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-xl);
        color: ${({theme}) => theme.mainTextColor};

        .arr-left{
          font-size: 1.2rem;
          color: #888;
        }
      }
  }

`;

const center = {
  lat: 39.35129, // Türkiye'nin koordinatları
  lng: 35.672607,
};


function pointToBounds({ lat, lng }, radiusKm = 40) {
  // 1° enlem ≈ 110.574 km
  const latDelta = radiusKm / 110.574;
  // 1° boylam ≈ 111.32 km × cos(enlem)
  const lngDelta =
    radiusKm / (111.32 * Math.cos((lat * Math.PI) / 180));

  return {
    north: lat + latDelta,
    south: lat - latDelta,
    east:  lng + lngDelta,
    west:  lng - lngDelta,
  };
}

const KonumGoruntuleme = () => {

  const mapRef = useRef(null);
  const dispatch = useDispatch();
  const hoverTimeout = useRef()
  const mapContainerRef = useRef(null);

  const {
    isLoadingGetRegionsBoundaries,
    isLoadingGetCitiesBoundaries,
    isLoadingGetTownsBoundaries,
    boundaryDepth,
    selectedRegion,
    selectedCity,
    selectedTown,
    regionsUserCounts,
    userBoundariesList,
    isListView,
    searchDepth,
    isLoadingGetSearchResultBoundaries
  } = useSelector((state) => state.boundaries);

  const {
    allUsersLocationList,
    filterDurationHour,
    filteredUser,
    isLoadingGetAllUsersLocation
  } = useSelector(state => state.locs)


  useEffect(() => {
    dispatch(getRegionsBoundaries());
  }, []);

  useEffect(() => {
      dispatch(getAllUsersLocation({
        duration: filterDurationHour
      }))
  },[])

  

useEffect(() => {
  if (!mapRef.current) return;

  let coords = null;

  // Öncelik: seçili ilçe
  if (selectedTown?.centerCoords && !isLoadingGetTownsBoundaries) {
    coords = selectedTown.centerCoords;
  }
  // seçili il
  else if (selectedCity?.centerCoords && !isLoadingGetCitiesBoundaries) {
    coords = selectedCity.centerCoords;
  }
  // seçili bölge
  else if (selectedRegion?.centerCoords && !isLoadingGetRegionsBoundaries) {
    coords = selectedRegion.centerCoords;
  }
  // Hiçbir veri yoksa varsayılan kutu
  else {
    coords = {
      north: 42.3,
      east:  44.9,
      south: 35.8,
      west:  25.6,
    };
  }

  if (coords) {
    const bounds = new window.google.maps.LatLngBounds();
    bounds.extend(new window.google.maps.LatLng(coords.north, coords.east));
    bounds.extend(new window.google.maps.LatLng(coords.south, coords.west));
    mapRef.current.fitBounds(bounds);

    // Minimum zoom: 6
    const minZoom = 6;
    const adjustZoom = () => {
      const currentZoom = mapRef.current.getZoom();
      if (currentZoom < minZoom) {
        mapRef.current.setZoom(minZoom);
      }
    };

    // idle ve zoom_changed olaylarında da kontrol et
    const idleListener = window.google.maps.event.addListenerOnce(
      mapRef.current,
      "idle",
      adjustZoom
    );
    const zoomListener = window.google.maps.event.addListenerOnce(
      mapRef.current,
      "zoom_changed",
      adjustZoom
    );

    // Fallback olarak requestAnimationFrame
    requestAnimationFrame(adjustZoom);

    return () => {
      idleListener.remove();
      zoomListener.remove();
    };
  }
}, [
  selectedTown?.centerCoords,
  selectedCity?.centerCoords,
  selectedRegion?.centerCoords,
  isLoadingGetTownsBoundaries,
  isLoadingGetCitiesBoundaries,
  isLoadingGetRegionsBoundaries,
]);


useEffect(() => {

  if (!mapRef.current) return;

  let coords = null;
  
  if (filteredUser?.latitude && filteredUser.longitude) {
    // 1 km yarıçaplı kutu
    coords = pointToBounds({ lat: filteredUser?.latitude, lng: filteredUser.longitude }, 40);
  }
  // Hiçbir veri yoksa varsayılan kutu
  else {
    coords = {
      north: 42.3,
      east:  44.9,
      south: 35.8,
      west:  25.6,
    };
  }

  if (coords) {
    const bounds = new window.google.maps.LatLngBounds();
    bounds.extend(new window.google.maps.LatLng(coords.north, coords.east));
    bounds.extend(new window.google.maps.LatLng(coords.south, coords.west));
    mapRef.current.fitBounds(bounds);

    // Minimum zoom: 6
    const minZoom = 6;
    const adjustZoom = () => {
      const currentZoom = mapRef.current.getZoom();
      if (currentZoom < minZoom) {
        mapRef.current.setZoom(minZoom);
      }
    };

    // idle ve zoom_changed olaylarında da kontrol et
    const idleListener = window.google.maps.event.addListenerOnce(
      mapRef.current,
      "idle",
      adjustZoom
    );
    const zoomListener = window.google.maps.event.addListenerOnce(
      mapRef.current,
      "zoom_changed",
      adjustZoom
    );

    // Fallback olarak requestAnimationFrame
    requestAnimationFrame(adjustZoom);

    return () => {
      idleListener.remove();
      zoomListener.remove();
    };
  }
},[filteredUser])


  useEffect(() => {
    
    if(searchDepth > 0 && selectedCity?.cityId){

        const insideUsersIds = userBoundariesList.filter(userItem => selectedCity.cityId === userItem.insideBoundaryCityId).map(userItem => userItem.id)
        
        dispatch(setFilteredUsersLocations({data: allUsersLocationList.filter(userItem => insideUsersIds.includes(userItem.id)), type: "filter"}))
    }

  },[searchDepth, selectedTown, selectedCity, selectedRegion, userBoundariesList])  


  return (
    <Container ref={mapContainerRef}>
      <div className="controller">
        <div className="part-list">
          <button className="part-item clickable" onClick={() => {boundaryDepth > 1 && dispatch(topSelectBoundaryDepth({type: 1})); dispatch(setIsListView(false))}}><BiSolidRightArrow  className="arr-icon"/> Türkiye</button>

          {
            boundaryDepth > 1 &&
            <button className={ "part-item clickable"} onClick={() => {boundaryDepth > 2 && dispatch(setFilteredUsersLocations({insideUsersIds: userBoundariesList.filter(userItem => selectedRegion.regionId === userItem.insideBoundaryRegionId).map(userItem => userItem.id), type:"reset2"})); dispatch(topSelectBoundaryDepth({type: 2}))}}><BiSolidRightArrow  className="arr-icon"/>{selectedRegion?.regionName}</button>
          }

          {
            boundaryDepth > 2 &&
            <button className={ "part-item clickable"} onClick={() => boundaryDepth > 3 && dispatch(topSelectBoundaryDepth({type: 3}))}><BiSolidRightArrow  className="arr-icon"/>{selectedCity?.cityName}</button>
          }

          {
            boundaryDepth > 3 &&
            <button className={ "part-item clickable"}><BiSolidRightArrow  className="arr-icon"/>{selectedTown?.townName}</button>
          }
        </div>
      </div>
      <GoogleMap
        mapContainerStyle={{
          width: isListView ? "calc(100% - 380px)" : "100%",
          height: "100%",
        }}
        zoom={7}
        center={center}
        options={{
          minZoom:6,
          mapTypeControl: false
        }}
        onLoad={(map) => (mapRef.current = map)}
      >
        {(isLoadingGetCitiesBoundaries || isLoadingGetRegionsBoundaries || isLoadingGetAllUsersLocation || isLoadingGetSearchResultBoundaries || regionsUserCounts?.length !== 7) && (
          <AbsoluteSpinner size="40px" color="#fff" bgColor="#E85446" />
        )}

        <div className="input-wrapper">
          <InputPlacesForBoundaries name={"placesforlocationview"} inputWidth={"340px"}/>
        </div>

        <div className="btn-wrapper">
          <button className="filter-btn" onClick={() => dispatch(setIsListView(!isListView))}>
            {
              !isListView ? 
              <>
                <BiSolidLeftArrow className="arr-left"/>Filtrele/Listele
              </>
              :
              <>
                Gizle <BiSolidRightArrow className="arr-left"/>
              </>
            }
          </button>
        </div>

        <RegionsBoundaries/>

        {boundaryDepth > 1 && <CitiesBoundaries />}

        {boundaryDepth > 2 && <TownsBoundaries />}
        
        {
          !isLoadingGetAllUsersLocation &&
          <UserLocations mapRef={mapRef} mapContainerRef={mapContainerRef} hoverTimeout={hoverTimeout}/>
        }

        <UserOverlay hoverTimeout={hoverTimeout}/>
       
      </GoogleMap>

      {
        isListView &&
        <UserList mapRef={mapRef} mapContainerRef={mapContainerRef} />
      }
    </Container>
  );
};

export default KonumGoruntuleme